export enum TypeOfTags {
	WORKSHOP_TAGS = 'worksHpp',
	PRIVATE_TAGS = 'private',
}

export enum TemplateModulesModalTabsEnum {
	MODULES = 'ORGANIZATION_MODULES',
	GALLERY = 'MODULE_GALLERY',
}
